import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Pagination, Keyboard } from "swiper"
import MapCards from "components/Cards/MapCards"

export default ({
  data = [],
  prevRef,
  nextRef,
  setLoading,
  xButton,
  handleDelete,
  setRefresh,
}) => {
  return (
    <div className="relative top-0 left-0 w-full max-w-full">
      <Swiper
        cssMode={true}
        slidesPerView={Math.min(data.length, 4)}
        spaceBetween={20}
        keyboard={{
          enabled: true,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          1100: {
            slidesPerView: 3,
          },
          1280: {
            slidesPerView: 4,
          },
          1440: {
            slidesPerView: 5,
          },
          1680: {
            slidesPerView: 6,
          },
        }}
        // loop={true}
        // pagination={{
        //   clickable: true,
        //   el: ".swiper-pagination",
        //   type: "bullets",
        //   renderBullet: (index, className) => {
        //     return '<span class="' + className + '">' + "</span>"
        //   },
        // }}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        modules={[Keyboard, Pagination, Navigation]}
        className="flex items-center justify-center mySwiper"
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onSwiper={(swiper) => {
          setTimeout(() => {
            swiper.params.navigation.prevEl = prevRef.current
            swiper.params.navigation.nextEl = nextRef.current
            swiper.navigation.destroy()
            swiper.navigation.init()
            swiper.navigation.update()
          })
        }}
      >
        {data?.map((item, idx) => {
          return (
            <SwiperSlide key={`${idx + 1}`}>
              {/* <div className="flex items-center justify-center"> */}
              {/* <WithImageCarousel data={item} setLoading={setLoading} FullImage={FullImage} XAction={XAction} withVievBtn={withVievBtn} handleDelete={handleDelete} /> */}
              {/* </div> */}
              <MapCards
                setRefresh={setRefresh}
                data={item}
                setLoading={setLoading}
                xButton={xButton}
                handleDelete={handleDelete}
              />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}
